import React from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import DoneOutlinedIcon from "@material-ui/icons/DoneOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ReplyOutlinedIcon from "@material-ui/icons/ReplyOutlined";
import LessonInfo from "./ThematicPlan/LessonInfo";
import {
  updateModuleLessonAction,
  getAllModuleLessonThemeAction
} from "../../../store/actions";

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1",
    marginBottom: -1,
    minHeight: 40,
    margin: 0,
    padding: 0,
    "& .MuiExpansionPanelSummary-content": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0,
      "&  p": {
        fontSize: 14,
        color: "#00334E",
        marginLeft: "10px",
        marginTop: "3px"
      },
      "& svg": {
        fill: "#00334E"
      }
    },
    "&$expanded": {
      minHeight: 40
    }
  },
  content: {
    "&$expanded": {}
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  }
}))(MuiExpansionPanelDetails);

const useStyles = makeStyles({
  caption: {
    display: "block",
    fontSize: "14px",
    lineHeight: "18px",
    marginBottom: "16px"
  }
});

const TrainingProgram = ({
  allModuleLessonTheme,
  getAllModuleLesson,
  updateModuleLesson,
  matchId
}) => {
  const { caption } = useStyles();
  const [expandedLesson, setExpandedLesson] = React.useState();
  const [isActiveEdit, setIsActiveEdit] = React.useState(null);

  const [lessons, setLessons] = React.useState();
  const [activeLesson, setActiveLesson] = React.useState();

  React.useEffect(() => {
    if (allModuleLessonTheme) {
      setLessons(allModuleLessonTheme);
    }
  }, [allModuleLessonTheme]);

  const editDescription = (idx, event) => {
    event.preventDefault();
    setIsActiveEdit(idx);
  };

  const changeDescription = (idx, event) => {
    const values = [...lessons];
    values[idx].description = event.target.value;
    setLessons(values);
  };

  const updateLesson = event => {
    const lesson = {
      main: {
        number: activeLesson.number,
        name: activeLesson.name,
        type: activeLesson.typeId,
        conduct: activeLesson.conductId,
        requirements: activeLesson.requirements
      },
      content: {
        description: activeLesson.description
      },
      sites: []
    };
    event.stopPropagation();
    updateModuleLesson(activeLesson.id, lesson);
  };

  const handleChangeLessonPanel = panel => (event, newExpandedLesson) => {
    setExpandedLesson(newExpandedLesson ? panel : false);
  };

  return (
    <Grid container direction="column">
      <span className={caption}>Учебная программа модуля</span>
      {lessons &&
        lessons.map((lesson, idx) => {
          return (
            <ExpansionPanel
              key={idx}
              square
              expanded={expandedLesson === `panel${lesson.id}`}
              onChange={handleChangeLessonPanel(`panel${lesson.id}`)}
            >
              <ExpansionPanelSummary>
                <div style={{ display: "flex" }}>
                  {expandedLesson === `panel${lesson.id}` ? (
                    <ArrowDropDownIcon />
                  ) : (
                    <ArrowRightIcon />
                  )}
                  <Typography>{`${lesson.typeName} ${lesson.number}. ${lesson.name}`}</Typography>
                </div>
                {isActiveEdit !== idx ? (
                  expandedLesson && (
                    <div style={{ marginRight: "16px" }}>
                      <Tooltip title="Редактировать" placement="top-start">
                        <IconButton
                          size="small"
                          onClick={event => {
                            setActiveLesson(lesson);
                            editDescription(idx, event);
                            event.stopPropagation();
                          }}
                        >
                          <EditOutlinedIcon
                            fontSize="small"
                            style={{ fill: "#93A7BE" }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  )
                ) : (
                  <div style={{ marginRight: "16px" }}>
                    <Tooltip title="Сохранить" placement="top-start">
                      <IconButton
                        size="small"
                        onClick={event =>
                          updateLesson(event) ||
                          setIsActiveEdit(null) ||
                          event.stopPropagation()
                        }
                      >
                        <DoneOutlinedIcon
                          fontSize="small"
                          style={{ fill: "#93A7BE" }}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Отмена" placement="top-start">
                      <IconButton
                        size="small"
                        onClick={event =>
                          setIsActiveEdit(null) ||
                          getAllModuleLesson(matchId) ||
                          event.stopPropagation()
                        }
                      >
                        <ReplyOutlinedIcon
                          fontSize="small"
                          style={{ fill: "#93A7BE" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <LessonInfo
                  type="trainingProgram"
                  form={lesson.conductName}
                  name={lesson.name}
                  purpose={lesson.requirements}
                  description={lesson.description || ""}
                  disabled={isActiveEdit === idx ? false : true}
                  changeDescription={event => changeDescription(idx, event)}
                />
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
    </Grid>
  );
};

const mapStateToProps = state => ({
  allModuleLessonTheme: state.modules.allModuleLessonTheme
});

const mapDispatchToProps = dispatch => ({
  updateModuleLesson: (id, data) =>
    dispatch(updateModuleLessonAction(id, data)),
  getAllModuleLesson: id => dispatch(getAllModuleLessonThemeAction(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingProgram);
